import { Button } from "@jhool-io/fe-components";
import { useErrorBoundary } from "react-error-boundary";
import styles from "./AppFallback.module.scss";

export default function AppFallback() {
    const { resetBoundary } = useErrorBoundary();

    return (
        <div className={styles.app}>
            <div className={styles.wrap}>
                <p className={styles.logo}>Mantle</p>
                <h3>Something went wrong</h3>
                <p>
                    You just encountered an unexpected error. We have been made
                    aware of it and we will address this issue as quickly as we
                    can. Please use the feedback button to provide more
                    information on the issue. Thank you for your understanding.
                </p>
                <Button
                    onClick={resetBoundary}
                    style={{
                        marginTop: "20px",
                    }}
                >
                    Go back
                </Button>
            </div>
        </div>
    );
}
